<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-title-row">
        <button class="editor-back" type="button" aria-label="Indietro" (click)="goBack()">
          <i class="bi bi-arrow-left" aria-hidden="true"></i>
          <span class="back-label">Indietro</span>
        </button>
        <div class="editor-banner">
          <img src="assets/img/contactBar.png" alt="">
          <h1>Modifica scheda</h1>
        </div>
      </div>
      <div class="editor-toolbar">
        <p class="editor-note">I campi con <sup>*</sup> sono obbligatori.</p>
        <a class="editor-secondary" [routerLink]="['/archivioArtistico/scheda', idarticle]">Visualizza scheda</a>
      </div>
    </header>

    <div class="editor-sections">
      <app-general-info [listType]="listComplete?.listType!" [listRegionsCode]="listComplete?.listRegionCode!" [idarticle]="idarticle"></app-general-info>
      <app-relations [idarticle]="idarticle"></app-relations>
      <app-object [listObject]="listComplete?.listObject!" [idarticle]="idarticle"></app-object>
      <app-geographic-location [idarticle]="idarticle"></app-geographic-location>
      <app-location-data [listLocation]="listComplete?.listLocation!" [idarticle]="idarticle"></app-location-data>
      <app-chronology [listChronology]="listChronology" [idarticle]="idarticle"></app-chronology>
      <app-cultural-definition [listCulturalDefinition]="listCulturalDefinition" [idarticle]="idarticle"></app-cultural-definition>
      <app-technical-data [idarticle]="idarticle" [listTechnicalData]="listTechnicalData"></app-technical-data>
      <app-conservation [idarticle]="idarticle" [statusOptions]="statusOptions"></app-conservation>
      <app-analytical-data [idarticle]="idarticle" [listAnalyicalData]="listAnalyicalData"></app-analytical-data>
      <app-legal-condition [idarticle]="idarticle" [listAcquisitionType]="listLegal?.acquisitionType!"
        [listGenericIndication]="listLegal?.listGenericIndication!"></app-legal-condition>
      <app-sources [idarticle]="idarticle" [listSourcesData]="listSourcesData"></app-sources>
    </div>
  </div>
</div>
